export default function PHP_close() {
  return (
    <div>
      <h1>PHP_close</h1>
    </div>
  );
}
